// extracted by mini-css-extract-plugin
export default {"container":"Report_container__Zpy2q"};